import React, {useMemo}								from 'react';

import Input										from '../ressources/components/Input';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import Select										from '../ressources/components/Select';
import Textarea										from '../ressources/components/Textarea';

import {useAppSelector}								from '../app/hooks';
import {InputValues}								from '../ressources/components/Input/interface';
import {SelectValues}								from '../ressources/components/Select/interface';

import {ft_selectDataGetMemory, ft_selectDataGetNetwork,
	ft_selectDataGetStockage, ft_selectDataString}	from '../ressources/functions/selectData';
import {ft_checkRight}								from '../ressources/functions/userFunction';

import LANGUAGE										from '../ressources/language';
import {STATE}										from '../ressources/data/form';
import * as DEVICE_DATA								from '../ressources/data/device';

import './Devices.css';

type SetSelect = (val: SelectValues) => void
type SetSelects = (val: SelectValues[]) => void
type SetInput = (val: InputValues) => void


interface Props {
	deviceType: string
	notValala?: boolean,

	state: SelectValues
	set_state: SetSelect
	internalId: InputValues
	set_internalId: SetInput
	serial: InputValues
	set_serial: SetInput
	imei: InputValues
	set_imei: SetInput
	imei2: InputValues
	set_imei2: SetInput
	screenSize: InputValues
	set_screenSize: SetInput
	stockage: SelectValues
	set_stockage: SetSelect
	memory: SelectValues
	set_memory: SetSelect
	processor: InputValues
	set_processor: SetInput
	graphicCard: InputValues
	set_graphicCard: SetInput
	network: SelectValues
	set_network: SetSelect
	gpu: InputValues
	set_gpu: SetInput
	keyboard: SelectValues
	set_keyboard: SetSelect
	description: InputValues
	set_description: SetInput
	definition: InputValues
	set_definition: SetInput
	compatibility: SelectValues[]
	set_compatibility: SetSelects
	refreshRate: InputValues
	set_refreshRate: SetInput
	responseTime: InputValues
	set_responseTime: SetInput
	ports: SelectValues[]
	set_ports: SetSelects
	connectivity: SelectValues[]
	set_connectivity: SetSelects
	subType: SelectValues
	set_subType: SetSelect
	batteryLife: InputValues
	set_batteryLife: SetInput
	anc: InputValues
	set_anc: SetInput
	stand: SelectValues[]
	set_stand: SetSelects
}

function DevicesCharacteristicForm(props: Props) {
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	const readonly = useMemo(() =>
		(!props.notValala || !ft_checkRight(user, 'company.edit'))
	, [user, props.notValala]);

	const onChangeSelectCheckbox = (data: SelectValues, value: SelectValues[], setValue: SetSelects) => {
		const copy = [...value];
		const index = value.findIndex(find => find === data);

		if (index !== -1)
			copy.splice(index, 1);
		else
			copy.push(data);

		setValue(copy);
	};

	const screenSize: InputValues = useMemo(() => {
		if (!props.screenSize || typeof props.screenSize === 'number')
			return props.screenSize;
		return parseFloat(props.screenSize);
	}, [props.screenSize]);

	return (
		<>
			<MultiInputContainer>
				<Input
					value={props.internalId}
					onChange={props.set_internalId}
					title={TEXTE.global.internalId}
				/>
				<Input
					readOnlySp
					value={props.serial}
					readOnly={readonly}
					onChange={props.set_serial}
					title={TEXTE.global.serial}
				/>
			</MultiInputContainer>

			{/* COMPUTER / PHONE / TABLET */}
			{(props.deviceType === 'computer' || props.deviceType === 'phone' || props.deviceType === 'tablet') &&
				<>
					{props.deviceType === 'phone' &&
						<MultiInputContainer>
							<Input
								readOnlySp
								value={props.imei}
								readOnly={readonly}
								onChange={props.set_imei}
								title={TEXTE.global.imei}
							/>
							<Input
								readOnlySp
								value={props.imei2}
								readOnly={readonly}
								onChange={props.set_imei2}
								title={`${TEXTE.global.imei} 2`}
							/>
						</MultiInputContainer>
					}
					<MultiInputContainer>
						<Input
							min={0}
							readOnlySp
							type={'number'}
							readOnly={readonly}
							placeholder={'10,1"'}
							value={props.screenSize}
							onChange={props.set_screenSize}
							title={TEXTE.global.screenSize}
							notFocusValue={screenSize ? `${screenSize}"` : undefined}
						/>
						{props.notValala &&
							<Select
								readOnlySp
								value={props.state}
								data={[{render: '', value: ''}, ...STATE(TEXTE)]}
								readOnly={readonly}
								onChange={props.set_state}
								title={TEXTE.global.state}
							/>
						}
					</MultiInputContainer>
					<MultiInputContainer>
						<Select
							readOnlySp
							value={props.stockage}
							readOnly={readonly}
							onChange={props.set_stockage}
							title={TEXTE.global.stockage}
							data={[{render: '', value: ''}, ...ft_selectDataGetStockage()]}
						/>
						<Select
							readOnlySp
							value={props.memory}
							readOnly={readonly}
							onChange={props.set_memory}
							title={TEXTE.global.memory}
							data={[{render: '', value: ''}, ...ft_selectDataGetMemory()]}
						/>
					</MultiInputContainer>
					<MultiInputContainer>
						<Input
							readOnlySp
							value={props.processor}
							readOnly={readonly}
							onChange={props.set_processor}
							title={TEXTE.global.processor}
						/>
						{(props.deviceType === 'computer') &&
							<Input
								readOnlySp
								value={props.graphicCard}
								readOnly={readonly}
								onChange={props.set_graphicCard}
								title={TEXTE.global.graphicCard}
							/>
						}
					</MultiInputContainer>
					<MultiInputContainer>
						<Select
							value={props.network}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_network}
							title={TEXTE.global.network}
							data={[{render: '', value: ''}, ...ft_selectDataGetNetwork()]}
						/>
						{(props.deviceType === 'computer') ?
							<Select
								value={props.keyboard}
								readOnlySp
								readOnly={readonly}
								onChange={props.set_keyboard}
								title={TEXTE.global.keyboard}
								data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.KEYBOARD_LIST)]}
							/>
							:
							<Input
								value={props.gpu}
								onChange={props.set_gpu}
								title={TEXTE.global.gpu}
								readOnlySp
								readOnly={readonly}
							/>
						}
					</MultiInputContainer>
				</>
			}

			{/* SCREEN */}
			{(props.deviceType === 'screen') &&
				<>
					<MultiInputContainer>
						<Input
							min={0}
							type={'number'}
							placeholder={'10,1"'}
							value={props.screenSize}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_screenSize}
							title={TEXTE.global.screenSize}
							notFocusValue={props.screenSize ? `${props.screenSize}"` : undefined}
						/>
						<Input
							value={props.definition}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_definition}
							title={TEXTE.global.definition}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Input
							min={0}
							type={'number'}
							value={props.refreshRate}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_refreshRate}
							title={TEXTE.global.refreshRate}
						/>
						<Input
							min={1}
							type={'number'}
							placeholder={'1ms'}
							value={props.responseTime}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_responseTime}
							title={TEXTE.global.responseTime}
							notFocusValue={props.responseTime ? `${props.responseTime}ms` : undefined}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Select
							value={props.compatibility}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.compatibility}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.SCREEN_COMPATIBILITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.compatibility, props.set_compatibility)}
							// onAdd={val => onChangeSelectCheckbox(val, compatibility, set_compatibility)}
						/>
						<Select
							value={props.ports}
							title={TEXTE.global.ports}
							readOnlySp
							readOnly={readonly}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.SCREEN_PORTS)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.ports, props.set_ports)}
							// onAdd={val => onChangeSelectCheckbox(val, ports, set_ports)}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Select
							value={props.stand}
							title={TEXTE.global.stand}
							readOnlySp
							readOnly={readonly}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.SCREEN_STAND)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.stand, props.set_stand)}
							// onAdd={val => onChangeSelectCheckbox(val, stand, set_stand)}
						/>
						{/* <Switch
							active={camera}
							onChange={props.set_camera}
							text={TEXTE.global.camera}
						/> */}
					</MultiInputContainer>
				</>
			}

			{/* MOUSE */}
			{(props.deviceType === 'mouse') &&
				<>
					<MultiInputContainer>
						<Select
							value={props.compatibility}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.compatibility}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.SCREEN_COMPATIBILITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.compatibility, props.set_compatibility)}
							// onAdd={val => onChangeSelectCheckbox(val, compatibility, set_compatibility)}
						/>
						<Select
							value={props.connectivity}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.connectivity}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.MOUSE_CONNECTIVITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.connectivity, props.set_connectivity)}
							// onAdd={val => onChangeSelectCheckbox(val, connectivity, set_connectivity)}
						/>
					</MultiInputContainer>
				</>
			}

			{/* HEADPHONES */}
			{(props.deviceType === 'headphones') &&
				<>
					<MultiInputContainer>
						<Select
							value={props.subType}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_subType}
							title={TEXTE.global.subType}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.HEADPHONES_TYPE)]}
						/>
						<Input
							min={0}
							type={'number'}
							value={props.batteryLife}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_batteryLife}
							title={TEXTE.global.batteryLife}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Input
							value={props.anc}
							onChange={props.set_anc}
							title={TEXTE.global.anc}
							readOnlySp
							readOnly={readonly}
						/>
						<Select
							value={props.connectivity}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.connectivity}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.HEADPHONES_CONNECTIVITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.connectivity, props.set_connectivity)}
							// onAdd={val => onChangeSelectCheckbox(val, connectivity, set_connectivity)}
						/>
					</MultiInputContainer>
				</>
			}

			{/* SPEAKER */}
			{(props.deviceType === 'speaker') &&
				<>
					<MultiInputContainer>
						<Select
							value={props.connectivity}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.connectivity}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.SPEAKER_CONNECTIVITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.connectivity, props.set_connectivity)}
							// onAdd={val => onChangeSelectCheckbox(val, connectivity, set_connectivity)}
						/>
						<Input
							min={0}
							type={'number'}
							value={props.batteryLife}
							readOnlySp
							readOnly={readonly}
							onChange={props.set_batteryLife}
							title={TEXTE.global.batteryLife}
						/>
					</MultiInputContainer>
				</>
			}

			{/* KEYBOARD */}
			{(props.deviceType === 'keyboard') &&
				<>
					<MultiInputContainer>
						<Select
							value={props.compatibility}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.compatibility}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.KEYBOARD_COMPATIBILITY)]}
							// onAdd={val => onChangeSelectCheckbox(val, compatibility, set_compatibility)}
							// onChange={props.val => onChangeSelectCheckbox(val, compatibility, set_compatibility)}
						/>
						<Select
							value={props.connectivity}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.connectivity}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.KEYBOARD_CONNECTIVITY)]}
							// onAdd={val => onChangeSelectCheckbox(val, connectivity, set_connectivity)}
							// onChange={props.val => onChangeSelectCheckbox(val, connectivity, set_connectivity)}
						/>
					</MultiInputContainer>
				</>
			}

			{/* HUB */}
			{(props.deviceType === 'hub') &&
				<>
					<MultiInputContainer>
						<Select
							value={props.compatibility}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.compatibility}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.HUB_COMPATIBILITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.compatibility, props.set_compatibility)}
							// onAdd={val => onChangeSelectCheckbox(val, compatibility, set_compatibility)}
						/>
						<Select
							value={props.connectivity}
							readOnlySp
							readOnly={readonly}
							title={TEXTE.global.connectivity}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.HUB_CONNECTIVITY)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.connectivity, props.set_connectivity)}
							// onAdd={val => onChangeSelectCheckbox(val, connectivity, set_connectivity)}
						/>
					</MultiInputContainer>

					<MultiInputContainer>
						<Select
							value={props.ports}
							title={TEXTE.global.ports}
							readOnlySp
							readOnly={readonly}
							data={[{render: '', value: ''}, ...ft_selectDataString(DEVICE_DATA.HUB_PORTS)]}
							onClickCheckbox={val => onChangeSelectCheckbox(val, props.ports, props.set_ports)}
							// onAdd={val => onChangeSelectCheckbox(val, ports, set_ports)}
						/>
					</MultiInputContainer>
				</>
			}

			<Textarea
				style={{height: 156}}
				value={props.description}
				onChange={props.set_description}
				title={TEXTE.global.descriptionAndNote}
				readOnly={!ft_checkRight(user, 'company.edit')}
			/>
		</>
	);
}

export default DevicesCharacteristicForm;